const getPandaDocFieldsBattery = (contract, lead, salesRepContact) => {
    
    let payload = {
        "recipients":
            [
                {  
                    "email": salesRepContact.Email,
                    "first_name": salesRepContact.FirstName,
                    "last_name": salesRepContact.LastName,
                    "role": "Sales Rep"
                },
                {
                    "email": contract.Email__c,
                    "first_name":lead.FirstName,
                    "last_name":lead.LastName,
                    "role": "Homeowner"
                }
            ],
        "name": lead.Name,
        "template_uuid":"WehMjGEShYwovrkLLsQHM2",
        "tokens": 
            [
                {
                    "name": "Batteries_Included__c",
                    "value": "Yes"
                },
                {
                    "name": "Monthly_Payment__c",
                    "value": String(Math.round(contract.Monthly_Payment__c * 100) / 100)
                },
                {
                    "name": "Escalator__c",
                    "value": String(contract.Escalator__c)
                },
                {
                    "name": "Customer_Name__c",
                    "value": String(contract.Customer_Name__c)
                },
                {
                    "name": "Phone_Number__c",
                    "value": String(contract.Phone_Number__c)
                },
                {
                    "name": "Email__c",
                    "value": String(contract.Email__c)
                },
                {
                    "name": "Street__c",
                    "value": String(contract.Street__c)
                },
                {
                    "name": "City__c",
                    "value": String(contract.City__c)
                },
                {
                    "name": "State__c",
                    "value": String(contract.State__c)
                },
                {
                    "name": "Zip__c",
                    "value": String(contract.Zip__c)
                },
                {
                    "name": "Sales_Rep_Name__c",
                    "value": String(salesRepContact.Name)
                },
                {
                    "name": "HIS_Number__c",
                    "value": String(contract.HIS_Number__c)
                },
                {
                    "name": "Approximate_Start_Date__c",
                    "value": String(contract.Approximate_Start_Date__c)
                },
                {
                    "name": "Approximate_Completion_Date__c",
                    "value": String(contract.Approximate_Completion_Date__c)
                },
                {
                    "name": "Amount_Due_at_Signing__c",
                    "value": String(Math.round(contract.Amount_Due_at_Signing__c * 100) / 100)
                },
                {
                    "name": "Initial_Term__c",
                    "value": String(contract.Initial_Term__c)
                },
                {
                    "name": "System_Size__c",
                    "value": String(contract.System_Size__c)
                },
                {
                    "name": "Number_of_Batteries__c",
                    "value": String(contract.Number_of_Batteries__c)
                },
                {
                    "name": "Number_of_Panels__c",
                    "value": String(contract.Number_of_Panels__c)
                },
                {
                    "name": "Number_of_Inverters__c",
                    "value": String(contract.Number_of_Inverters__c)
                },
                {
                    "name": "Year_1_Estimated_Output__c",
                    "value": String(contract.Year_1_Estimated_Output__c)
                },
                {
                    "name": "Approximate_Offset__c",
                    "value": String(contract.Approximate_Offset__c)
                },
                {
                    "name": "Estimated_Year_One_Production__c",
                    "value": String(contract.Estimated_Year_One_Production__c)
                },
                {
                    "name": "Total_Production_over_Term__c",
                    "value": String(contract.Total_Production_over_Term__c)
                },
                {
                    "name": "Year_1_Estimated_Output__c",
                    "value": contract.Year_1_Estimated_Output__c
                },
                {
                    "name": "Year_1_Estimated_Prepayment_Price__c",
                    "value": contract.Year_1_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_1_Guaranteed_Output__c",
                    "value": contract.Year_1_Guaranteed_Output__c
                },
                {
                    "name": "Year_1_Battery_Payment__c",
                    "value": contract.Year_1_Battery_Payment__c
                },
                {
                    "name": "Year_1_Solar_Payment__c",
                    "value": contract.Year_1_Solar_Payment__c
                },
                {
                    "name": "Year_1_Monthly_Payment__c",
                    "value": contract.Year_1_Monthly_Payment__c
                },
                {
                    "name": "Year_1_Refund_per_kWh__c",
                    "value": contract.Year_1_Refund_per_kWh__c
                },
                {
                    "name": "Year_2_Estimated_Output__c",
                    "value": contract.Year_2_Estimated_Output__c
                },
                {
                    "name": "Year_2_Estimated_Prepayment_Price__c",
                    "value": contract.Year_2_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_2_Guaranteed_Output__c",
                    "value": contract.Year_2_Guaranteed_Output__c
                },
                {
                    "name": "Year_2_Battery_Payment__c",
                    "value": contract.Year_2_Battery_Payment__c
                },
                {
                    "name": "Year_2_Solar_Payment__c",
                    "value": contract.Year_2_Solar_Payment__c
                },
                {
                    "name": "Year_2_Monthly_Payment__c",
                    "value": contract.Year_2_Monthly_Payment__c
                },
                {
                    "name": "Year_2_Refund_per_kWh__c",
                    "value": contract.Year_2_Refund_per_kWh__c
                },
                {
                    "name": "Year_3_Estimated_Output__c",
                    "value": contract.Year_3_Estimated_Output__c
                },
                {
                    "name": "Year_3_Estimated_Prepayment_Price__c",
                    "value": contract.Year_3_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_3_Guaranteed_Output__c",
                    "value": contract.Year_3_Guaranteed_Output__c
                },
                {
                    "name": "Year_3_Battery_Payment__c",
                    "value": contract.Year_3_Battery_Payment__c
                },
                {
                    "name": "Year_3_Solar_Payment__c",
                    "value": contract.Year_3_Solar_Payment__c
                },
                {
                    "name": "Year_3_Monthly_Payment__c",
                    "value": contract.Year_3_Monthly_Payment__c
                },
                {
                    "name": "Year_3_Refund_per_kWh__c",
                    "value": contract.Year_3_Refund_per_kWh__c
                },
                {
                    "name": "Year_4_Estimated_Output__c",
                    "value": contract.Year_4_Estimated_Output__c
                },
                {
                    "name": "Year_4_Estimated_Prepayment_Price__c",
                    "value": contract.Year_4_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_4_Guaranteed_Output__c",
                    "value": contract.Year_4_Guaranteed_Output__c
                },
                {
                    "name": "Year_4_Battery_Payment__c",
                    "value": contract.Year_4_Battery_Payment__c
                },
                {
                    "name": "Year_4_Solar_Payment__c",
                    "value": contract.Year_4_Solar_Payment__c
                },
                {
                    "name": "Year_4_Monthly_Payment__c",
                    "value": contract.Year_4_Monthly_Payment__c
                },
                {
                    "name": "Year_4_Refund_per_kWh__c",
                    "value": contract.Year_4_Refund_per_kWh__c
                },
                {
                    "name": "Year_5_Estimated_Output__c",
                    "value": contract.Year_5_Estimated_Output__c
                },
                {
                    "name": "Year_5_Estimated_Prepayment_Price__c",
                    "value": contract.Year_5_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_5_Guaranteed_Output__c",
                    "value": contract.Year_5_Guaranteed_Output__c
                },
                {
                    "name": "Year_5_Battery_Payment__c",
                    "value": contract.Year_5_Battery_Payment__c
                },
                {
                    "name": "Year_5_Solar_Payment__c",
                    "value": contract.Year_5_Solar_Payment__c
                },
                {
                    "name": "Year_5_Monthly_Payment__c",
                    "value": contract.Year_5_Monthly_Payment__c
                },
                {
                    "name": "Year_5_Refund_per_kWh__c",
                    "value": contract.Year_5_Refund_per_kWh__c
                },
                {
                    "name": "Year_6_Estimated_Output__c",
                    "value": contract.Year_6_Estimated_Output__c
                },
                {
                    "name": "Year_6_Estimated_Prepayment_Price__c",
                    "value": contract.Year_6_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_6_Guaranteed_Output__c",
                    "value": contract.Year_6_Guaranteed_Output__c
                },
                {
                    "name": "Year_6_Battery_Payment__c",
                    "value": contract.Year_6_Battery_Payment__c
                },
                {
                    "name": "Year_6_Solar_Payment__c",
                    "value": contract.Year_6_Solar_Payment__c
                },
                {
                    "name": "Year_6_Monthly_Payment__c",
                    "value": contract.Year_6_Monthly_Payment__c
                },
                {
                    "name": "Year_6_Refund_per_kWh__c",
                    "value": contract.Year_6_Refund_per_kWh__c
                },
                {
                    "name": "Year_7_Estimated_Output__c",
                    "value": contract.Year_7_Estimated_Output__c
                },
                {
                    "name": "Year_7_Estimated_Prepayment_Price__c",
                    "value": contract.Year_7_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_7_Guaranteed_Output__c",
                    "value": contract.Year_7_Guaranteed_Output__c
                },
                {
                    "name": "Year_7_Battery_Payment__c",
                    "value": contract.Year_7_Battery_Payment__c
                },
                {
                    "name": "Year_7_Solar_Payment__c",
                    "value": contract.Year_7_Solar_Payment__c
                },
                {
                    "name": "Year_7_Monthly_Payment__c",
                    "value": contract.Year_7_Monthly_Payment__c
                },
                {
                    "name": "Year_7_Refund_per_kWh__c",
                    "value": contract.Year_7_Refund_per_kWh__c
                },
                {
                    "name": "Year_8_Estimated_Output__c",
                    "value": contract.Year_8_Estimated_Output__c
                },
                {
                    "name": "Year_8_Estimated_Prepayment_Price__c",
                    "value": contract.Year_8_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_8_Guaranteed_Output__c",
                    "value": contract.Year_8_Guaranteed_Output__c
                },
                {
                    "name": "Year_8_Battery_Payment__c",
                    "value": contract.Year_8_Battery_Payment__c
                },
                {
                    "name": "Year_8_Solar_Payment__c",
                    "value": contract.Year_8_Solar_Payment__c
                },
                {
                    "name": "Year_8_Monthly_Payment__c",
                    "value": contract.Year_8_Monthly_Payment__c
                },
                {
                    "name": "Year_8_Refund_per_kWh__c",
                    "value": contract.Year_8_Refund_per_kWh__c
                },
                {
                    "name": "Year_9_Estimated_Output__c",
                    "value": contract.Year_9_Estimated_Output__c
                },
                {
                    "name": "Year_9_Estimated_Prepayment_Price__c",
                    "value": contract.Year_9_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_9_Guaranteed_Output__c",
                    "value": contract.Year_9_Guaranteed_Output__c
                },
                {
                    "name": "Year_9_Battery_Payment__c",
                    "value": contract.Year_9_Battery_Payment__c
                },
                {
                    "name": "Year_9_Solar_Payment__c",
                    "value": contract.Year_9_Solar_Payment__c
                },
                {
                    "name": "Year_9_Monthly_Payment__c",
                    "value": contract.Year_9_Monthly_Payment__c
                },
                {
                    "name": "Year_9_Refund_per_kWh__c",
                    "value": contract.Year_9_Refund_per_kWh__c
                },
                {
                    "name": "Year_10_Estimated_Output__c",
                    "value": contract.Year_10_Estimated_Output__c
                },
                {
                    "name": "Year_10_Estimated_Prepayment_Price__c",
                    "value": contract.Year_10_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_10_Guaranteed_Output__c",
                    "value": contract.Year_10_Guaranteed_Output__c
                },
                {
                    "name": "Year_10_Battery_Payment__c",
                    "value": contract.Year_10_Battery_Payment__c
                },
                {
                    "name": "Year_10_Solar_Payment__c",
                    "value": contract.Year_10_Solar_Payment__c
                },
                {
                    "name": "Year_10_Monthly_Payment__c",
                    "value": contract.Year_10_Monthly_Payment__c
                },
                {
                    "name": "Year_10_Refund_per_kWh__c",
                    "value": contract.Year_10_Refund_per_kWh__c
                },
                {
                    "name": "Year_11_Estimated_Output__c",
                    "value": contract.Year_11_Estimated_Output__c
                },
                {
                    "name": "Year_11_Estimated_Prepayment_Price__c",
                    "value": contract.Year_11_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_11_Guaranteed_Output__c",
                    "value": contract.Year_11_Guaranteed_Output__c
                },
                {
                    "name": "Year_11_Battery_Payment__c",
                    "value": contract.Year_11_Battery_Payment__c
                },
                {
                    "name": "Year_11_Solar_Payment__c",
                    "value": contract.Year_11_Solar_Payment__c
                },
                {
                    "name": "Year_11_Monthly_Payment__c",
                    "value": contract.Year_11_Monthly_Payment__c
                },
                {
                    "name": "Year_11_Refund_per_kWh__c",
                    "value": contract.Year_11_Refund_per_kWh__c
                },
                {
                    "name": "Year_12_Estimated_Output__c",
                    "value": contract.Year_12_Estimated_Output__c
                },
                {
                    "name": "Year_12_Estimated_Prepayment_Price__c",
                    "value": contract.Year_12_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_12_Guaranteed_Output__c",
                    "value": contract.Year_12_Guaranteed_Output__c
                },
                {
                    "name": "Year_12_Battery_Payment__c",
                    "value": contract.Year_12_Battery_Payment__c
                },
                {
                    "name": "Year_12_Solar_Payment__c",
                    "value": contract.Year_12_Solar_Payment__c
                },
                {
                    "name": "Year_12_Monthly_Payment__c",
                    "value": contract.Year_12_Monthly_Payment__c
                },
                {
                    "name": "Year_12_Refund_per_kWh__c",
                    "value": contract.Year_12_Refund_per_kWh__c
                },
                {
                    "name": "Year_13_Estimated_Output__c",
                    "value": contract.Year_13_Estimated_Output__c
                },
                {
                    "name": "Year_13_Estimated_Prepayment_Price__c",
                    "value": contract.Year_13_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_13_Guaranteed_Output__c",
                    "value": contract.Year_13_Guaranteed_Output__c
                },
                {
                    "name": "Year_13_Battery_Payment__c",
                    "value": contract.Year_13_Battery_Payment__c
                },
                {
                    "name": "Year_13_Solar_Payment__c",
                    "value": contract.Year_13_Solar_Payment__c
                },
                {
                    "name": "Year_13_Monthly_Payment__c",
                    "value": contract.Year_13_Monthly_Payment__c
                },
                {
                    "name": "Year_13_Refund_per_kWh__c",
                    "value": contract.Year_13_Refund_per_kWh__c
                },
                {
                    "name": "Year_14_Estimated_Output__c",
                    "value": contract.Year_14_Estimated_Output__c
                },
                {
                    "name": "Year_14_Estimated_Prepayment_Price__c",
                    "value": contract.Year_14_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_14_Guaranteed_Output__c",
                    "value": contract.Year_14_Guaranteed_Output__c
                },
                {
                    "name": "Year_14_Battery_Payment__c",
                    "value": contract.Year_14_Battery_Payment__c
                },
                {
                    "name": "Year_14_Solar_Payment__c",
                    "value": contract.Year_14_Solar_Payment__c
                },
                {
                    "name": "Year_14_Monthly_Payment__c",
                    "value": contract.Year_14_Monthly_Payment__c
                },
                {
                    "name": "Year_14_Refund_per_kWh__c",
                    "value": contract.Year_14_Refund_per_kWh__c
                },
                {
                    "name": "Year_15_Estimated_Output__c",
                    "value": contract.Year_15_Estimated_Output__c
                },
                {
                    "name": "Year_15_Estimated_Prepayment_Price__c",
                    "value": contract.Year_15_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_15_Guaranteed_Output__c",
                    "value": contract.Year_15_Guaranteed_Output__c
                },
                {
                    "name": "Year_15_Battery_Payment__c",
                    "value": contract.Year_15_Battery_Payment__c
                },
                {
                    "name": "Year_15_Solar_Payment__c",
                    "value": contract.Year_15_Solar_Payment__c
                },
                {
                    "name": "Year_15_Monthly_Payment__c",
                    "value": contract.Year_15_Monthly_Payment__c
                },
                {
                    "name": "Year_15_Refund_per_kWh__c",
                    "value": contract.Year_15_Refund_per_kWh__c
                },
                {
                    "name": "Year_16_Estimated_Output__c",
                    "value": contract.Year_16_Estimated_Output__c
                },
                {
                    "name": "Year_16_Estimated_Prepayment_Price__c",
                    "value": contract.Year_16_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_16_Guaranteed_Output__c",
                    "value": contract.Year_16_Guaranteed_Output__c
                },
                {
                    "name": "Year_16_Battery_Payment__c",
                    "value": contract.Year_16_Battery_Payment__c
                },
                {
                    "name": "Year_16_Solar_Payment__c",
                    "value": contract.Year_16_Solar_Payment__c
                },
                {
                    "name": "Year_16_Monthly_Payment__c",
                    "value": contract.Year_16_Monthly_Payment__c
                },
                {
                    "name": "Year_16_Refund_per_kWh__c",
                    "value": contract.Year_16_Refund_per_kWh__c
                },
                {
                    "name": "Year_17_Estimated_Output__c",
                    "value": contract.Year_17_Estimated_Output__c
                },
                {
                    "name": "Year_17_Estimated_Prepayment_Price__c",
                    "value": contract.Year_17_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_17_Guaranteed_Output__c",
                    "value": contract.Year_17_Guaranteed_Output__c
                },
                {
                    "name": "Year_17_Battery_Payment__c",
                    "value": contract.Year_17_Battery_Payment__c
                },
                {
                    "name": "Year_17_Solar_Payment__c",
                    "value": contract.Year_17_Solar_Payment__c
                },
                {
                    "name": "Year_17_Monthly_Payment__c",
                    "value": contract.Year_17_Monthly_Payment__c
                },
                {
                    "name": "Year_17_Refund_per_kWh__c",
                    "value": contract.Year_17_Refund_per_kWh__c
                },
                {
                    "name": "Year_18_Estimated_Output__c",
                    "value": contract.Year_18_Estimated_Output__c
                },
                {
                    "name": "Year_18_Estimated_Prepayment_Price__c",
                    "value": contract.Year_18_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_18_Guaranteed_Output__c",
                    "value": contract.Year_18_Guaranteed_Output__c
                },
                {
                    "name": "Year_18_Battery_Payment__c",
                    "value": contract.Year_18_Battery_Payment__c
                },
                {
                    "name": "Year_18_Solar_Payment__c",
                    "value": contract.Year_18_Solar_Payment__c
                },
                {
                    "name": "Year_18_Monthly_Payment__c",
                    "value": contract.Year_18_Monthly_Payment__c
                },
                {
                    "name": "Year_18_Refund_per_kWh__c",
                    "value": contract.Year_18_Refund_per_kWh__c
                },
                {
                    "name": "Year_19_Estimated_Output__c",
                    "value": contract.Year_19_Estimated_Output__c
                },
                {
                    "name": "Year_19_Estimated_Prepayment_Price__c",
                    "value": contract.Year_19_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_19_Guaranteed_Output__c",
                    "value": contract.Year_19_Guaranteed_Output__c
                },
                {
                    "name": "Year_19_Battery_Payment__c",
                    "value": contract.Year_19_Battery_Payment__c
                },
                {
                    "name": "Year_19_Solar_Payment__c",
                    "value": contract.Year_19_Solar_Payment__c
                },
                {
                    "name": "Year_19_Monthly_Payment__c",
                    "value": contract.Year_19_Monthly_Payment__c
                },
                {
                    "name": "Year_19_Refund_per_kWh__c",
                    "value": contract.Year_19_Refund_per_kWh__c
                },
                {
                    "name": "Year_20_Estimated_Output__c",
                    "value": contract.Year_20_Estimated_Output__c
                },
                {
                    "name": "Year_20_Estimated_Prepayment_Price__c",
                    "value": contract.Year_20_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_20_Guaranteed_Output__c",
                    "value": contract.Year_20_Guaranteed_Output__c
                },
                {
                    "name": "Year_20_Battery_Payment__c",
                    "value": contract.Year_20_Battery_Payment__c
                },
                {
                    "name": "Year_20_Solar_Payment__c",
                    "value": contract.Year_20_Solar_Payment__c
                },
                {
                    "name": "Year_20_Monthly_Payment__c",
                    "value": contract.Year_20_Monthly_Payment__c
                },
                {
                    "name": "Year_20_Refund_per_kWh__c",
                    "value": contract.Year_20_Refund_per_kWh__c
                },
                {
                    "name": "Year_21_Estimated_Output__c",
                    "value": contract.Year_21_Estimated_Output__c
                },
                {
                    "name": "Year_21_Estimated_Prepayment_Price__c",
                    "value": contract.Year_21_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_21_Guaranteed_Output__c",
                    "value": contract.Year_21_Guaranteed_Output__c
                },
                {
                    "name": "Year_21_Battery_Payment__c",
                    "value": contract.Year_21_Battery_Payment__c
                },
                {
                    "name": "Year_21_Solar_Payment__c",
                    "value": contract.Year_21_Solar_Payment__c
                },
                {
                    "name": "Year_21_Monthly_Payment__c",
                    "value": contract.Year_21_Monthly_Payment__c
                },
                {
                    "name": "Year_21_Refund_per_kWh__c",
                    "value": contract.Year_21_Refund_per_kWh__c
                },
                {
                    "name": "Year_22_Estimated_Output__c",
                    "value": contract.Year_22_Estimated_Output__c
                },
                {
                    "name": "Year_22_Estimated_Prepayment_Price__c",
                    "value": contract.Year_22_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_22_Guaranteed_Output__c",
                    "value": contract.Year_22_Guaranteed_Output__c
                },
                {
                    "name": "Year_22_Battery_Payment__c",
                    "value": contract.Year_22_Battery_Payment__c
                },
                {
                    "name": "Year_22_Solar_Payment__c",
                    "value": contract.Year_22_Solar_Payment__c
                },
                {
                    "name": "Year_22_Monthly_Payment__c",
                    "value": contract.Year_22_Monthly_Payment__c
                },
                {
                    "name": "Year_22_Refund_per_kWh__c",
                    "value": contract.Year_22_Refund_per_kWh__c
                },
                {
                    "name": "Year_23_Estimated_Output__c",
                    "value": contract.Year_23_Estimated_Output__c
                },
                {
                    "name": "Year_23_Estimated_Prepayment_Price__c",
                    "value": contract.Year_23_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_23_Guaranteed_Output__c",
                    "value": contract.Year_23_Guaranteed_Output__c
                },
                {
                    "name": "Year_23_Battery_Payment__c",
                    "value": contract.Year_23_Battery_Payment__c
                },
                {
                    "name": "Year_23_Solar_Payment__c",
                    "value": contract.Year_23_Solar_Payment__c
                },
                {
                    "name": "Year_23_Monthly_Payment__c",
                    "value": contract.Year_23_Monthly_Payment__c
                },
                {
                    "name": "Year_23_Refund_per_kWh__c",
                    "value": contract.Year_23_Refund_per_kWh__c
                },
                {
                    "name": "Year_24_Estimated_Output__c",
                    "value": contract.Year_24_Estimated_Output__c
                },
                {
                    "name": "Year_24_Estimated_Prepayment_Price__c",
                    "value": contract.Year_24_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_24_Guaranteed_Output__c",
                    "value": contract.Year_24_Guaranteed_Output__c
                },
                {
                    "name": "Year_24_Battery_Payment__c",
                    "value": contract.Year_24_Battery_Payment__c
                },
                {
                    "name": "Year_24_Solar_Payment__c",
                    "value": contract.Year_24_Solar_Payment__c
                },
                {
                    "name": "Year_24_Monthly_Payment__c",
                    "value": contract.Year_24_Monthly_Payment__c
                },
                {
                    "name": "Year_24_Refund_per_kWh__c",
                    "value": contract.Year_24_Refund_per_kWh__c
                },
                {
                    "name": "Year_25_Estimated_Output__c",
                    "value": contract.Year_25_Estimated_Output__c
                },
                {
                    "name": "Year_25_Estimated_Prepayment_Price__c",
                    "value": contract.Year_25_Estimated_Prepayment_Price__c
                },
                {
                    "name": "Year_25_Guaranteed_Output__c",
                    "value": contract.Year_25_Guaranteed_Output__c
                },
                {
                    "name": "Year_25_Battery_Payment__c",
                    "value": contract.Year_25_Battery_Payment__c
                },
                {
                    "name": "Year_25_Solar_Payment__c",
                    "value": contract.Year_25_Solar_Payment__c
                },
                {
                    "name": "Year_25_Monthly_Payment__c",
                    "value": contract.Year_25_Monthly_Payment__c
                },
                {
                    "name": "Year_25_Refund_per_kWh__c",
                    "value": contract.Year_25_Refund_per_kWh__c
                }
            ]
    }

    return payload;
};

export default getPandaDocFieldsBattery;